export function SET(state, payload) {
  state[payload.state] = payload.data;
}
export function CLEAR(state, stateName) {
  state[stateName] = {};
}